(function ($, App, Utils, Components, Pages) {
  'use strict';

  const logger = new Logger('GtmTrackPage');

  Pages.create('GtmTrackPage', {
    Selectors: {
      hpBannerPromo: '.t-homepage #wrapper > .c-carousel, .t-homepage-super #wrapper > .c-carousel, .t-homepage-local #wrapper > .c-carousel',
      hpLocalBannerPromo: '.t-homepage-local #wrapper > .c-carousel',
      storeCarousel: '.store-carousel',
      contactUs: '.t-contact-us',
      banner: ".card.card-editorial:not('.card-editorial-news')",
      bannerNew: '.card-editorial.with-footer, .card-editorial-news',
      cardTitle: '.card-title'
    },
    bindEvents: () => {
      logger.d('GtmTrackPage init');
      if (!window.dataLayer) return;

      const dataObj = {
        event: 'view_promotion',
        ecommerce: {
          promotions: []
        }
      }

      // SLIDER
      const $HpBannerPromo =  $(Pages.GtmTrackPage.Selectors.hpBannerPromo);
      if ($HpBannerPromo.length > 0) {
        const promoList = $HpBannerPromo.find('.slick-track .slick-slide').not(".slick-cloned");
        Pages.GtmTrackPage.promoTrack(promoList, 'slider');
      }

      // STORE CAROUSEL
      const $storeCarousel = $(Pages.GtmTrackPage.Selectors.storeCarousel);
      if ($storeCarousel.length > 0) {
        const promoList = $storeCarousel.find('.slick-track .slick-slide').not(".slick-cloned");
        Pages.GtmTrackPage.promoTrack(promoList, 'slider');
      }

      // BANNER IN EVIDENZA
      const bannerList = $(Pages.GtmTrackPage.Selectors.banner).not(".with-footer").not(".emphasize-footer").not(".no-tracking");
      Pages.GtmTrackPage.promoTrack(bannerList, 'banner_box');

      // BANNER NOVITA'
      const bannerNewList = $(Pages.GtmTrackPage.Selectors.bannerNew);
      Pages.GtmTrackPage.promoTrack(bannerNewList, 'novita');

      // CONTATTI
      const contactUs = $(Pages.GtmTrackPage.Selectors.contactUs).find(".callout.success");
      if(contactUs.length > 0) {
        Utils.trackGTM({ 'event': 'formContact' });
      }

    },

    promoTrack(promoList, promoType) {

      if (promoList.length <= 0) return;

      const dataObj = {
        'event': 'promotionView',
        'ecommerce': {
          'promoView': {
            'promotions': []
          }
        }
      }

      let location;
      switch (promoType) {
        case 'slider':
          location = 'slide';
        case 'banner_box':
        case 'novita':
          location = 'box';
      }

      promoList.each(function (index){
        let url = $(this).find(".float-link").attr("href") || $(this).data('link');
        url = (typeof url != 'undefined') && url.endsWith('/') ? url.substring(0, url.length - 1) : url;
        let validity = $(this).data('validity') != null ? $(this).data('validity') : new Date().getFullYear();
        let creativeSlot = $(this).data('creative-slot') != null ? $(this).data('creative-slot') : '';
        let lastPath = Utils.lastPathName(url);
        let title = $(this).find(Pages.GtmTrackPage.Selectors.cardTitle).html();
        let promotionName;

        if (Utils.isAbsoluteUrl(url)) {
          promotionName = Utils.sanitizeUrl(url);
        } else {
          promotionName = lastPath;
          if (title) {
            promotionName +=  `_${Utils.slugify(title)}`
          }
        }

        let promotion_id = `${validity}_${lastPath}`;
        let promoObj = {
          'id': promotion_id,
          'name': promotionName,
          'creative': `${promoType}_${creativeSlot}`,
          'position': `${location}${index}`
        }

        dataObj.ecommerce.promoView.promotions.push(promoObj)

        $(this).on('click', (e)=> {
          const dataObjClick = {
            'event': 'promotionClick',
            'ecommerce': {
              'promoClick': {
                'promotions': []
              }
            }
          }

          dataObjClick.ecommerce.promoClick.promotions.push({
            'id': promotion_id,
            'name': promotionName,
            'creative': `${promoType}_${creativeSlot}`,
            'position': `${location}${index}`
          });
          Utils.trackGTM(dataObjClick)
        });

      });
      Utils.trackGTM(dataObj);
    },
    init: () => {
      Pages.GtmTrackPage.bindEvents();
    }

  });
})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components,
    window.App.Pages
);
